import uid from "common/utils/uid";
import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_345: DocMigration = {
  maxSchemaVersion: "0.0.345",
  description: "Use legacy font size scaling to maintain baselines",
  apply(json: any) {
    if (!json.settings) {
      return json;
    }

    const settingsSetId = uid();
    const settingsSet = {
      id: settingsSetId,
      name: "Legacy Font Scaling Plan Settings",
      type: "GLOBAL",
      sortIndex: 0,
      entityType: "SETTINGS_SET",
    };

    const planSettingsId = uid();
    const planSettings = {
      entityType: "SETTINGS",
      type: "PLAN_SETTINGS",
      id: planSettingsId,
      name: "Plan Settings",
      sortIndex: 0,
      parentId: settingsSetId,
      enableLegacyFontScaling: true,
    };

    json.settings[planSettingsId] = planSettings;
    json.settingsSets[settingsSetId] = settingsSet;

    return json;
  },
};

export default migration_0_0_345;
